import * as THREE from 'three';
import { GRAVITY, TERMINAL_VELOCITY, EYE_HEIGHT, WORLD_LIMIT } from '../constants.js';
import { AABB } from '../physics/AABB.js';
import { moveWithCollision } from '../physics/Collision.js';

export class Player {
  constructor() {
    this.position = new THREE.Vector3(0, 80, 0);
    this.prevPosition = this.position.clone();
    this.velocity = new THREE.Vector3(0, 0, 0);
    this.onGround = false;
    this.flying = false;
    this.inWater = false;
    this.wasInWater = false;
  }

  toggleFlying() {
    this.flying = !this.flying;
    if (this.flying) {
      this.velocity.y = 0;
    }
  }

  update(dt, world) {
    this.prevPosition.copy(this.position);
    this.wasInWater = this.inWater;

    // Check if player is in water
    const feetY = Math.floor(this.position.y + 0.1);
    const eyeY = Math.floor(this.position.y + EYE_HEIGHT);
    const px = Math.floor(this.position.x);
    const pz = Math.floor(this.position.z);
    this.inWater = world.isWater(px, feetY, pz) || world.isWater(px, eyeY, pz);

    if (this.inWater && !this.flying) {
      // Water physics: reduced gravity, drag
      this.velocity.y += GRAVITY * 0.3 * dt;
      this.velocity.y *= 0.95; // water drag
      if (this.velocity.y < -5) this.velocity.y = -5;
      // Horizontal drag
      this.velocity.x *= 0.98;
      this.velocity.z *= 0.98;
    } else if (!this.flying) {
      this.velocity.y += GRAVITY * dt;
      if (this.velocity.y < TERMINAL_VELOCITY) {
        this.velocity.y = TERMINAL_VELOCITY;
      }
    } else {
      this.velocity.y *= 0.9;
    }

    // Spectator mode: skip collision, move freely through blocks
    if (this.noCollision) {
      this.position.x += this.velocity.x * dt;
      this.position.y += this.velocity.y * dt;
      this.position.z += this.velocity.z * dt;
      this.onGround = false;
    } else {
      const aabb = AABB.fromPlayer(this.position.x, this.position.y, this.position.z);
      this.onGround = moveWithCollision(world, aabb, this.velocity, dt);
      this.position.x = (aabb.minX + aabb.maxX) / 2;
      this.position.y = aabb.minY;
      this.position.z = (aabb.minZ + aabb.maxZ) / 2;
    }

    this.position.x = Math.max(-WORLD_LIMIT, Math.min(WORLD_LIMIT, this.position.x));
    this.position.z = Math.max(-WORLD_LIMIT, Math.min(WORLD_LIMIT, this.position.z));
    if (this.position.y < 0) this.position.y = 0;
  }

  interpolateCamera(alpha, camera) {
    const prevEye = this.prevPosition.clone();
    prevEye.y += EYE_HEIGHT;
    const currEye = this.position.clone();
    currEye.y += EYE_HEIGHT;
    camera.position.lerpVectors(prevEye, currEye, alpha);
  }
}
